

exports.__esModule = true;
exports.$xoDeGuest = undefined;

var _angular = require('angular');

var _integration = require('js/lib/integration');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _credit = require('xo-models/src/credit');

var _profilemanagement = require('xo-models/src/profilemanagement');

var _util = require('xo-return-to-merchant/dist/util');

var $xoDeGuest = exports.$xoDeGuest = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'xoDeGuest',
    resolve: {
        action: function action() {
            function returnMethod(merchantPreferences) {
                if (_integration.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                // When "redirect_uri" is passed as a query param
                if (_integration.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    return _squid.$util.param('redirect_uri');
                }

                if (_integration.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return checkoutAppData.urls.return_url;
            }

            function returnParams(checkoutCart, checkoutAppData, checkoutSession, returnToMerchantMethod) {
                var params = {};

                params.PayerID = checkoutSession.payer.id;

                var billingData = checkoutCart.billing;

                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                // When "redirect_uri" is passed as a query param
                if (_integration.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    params.opType = 'payment';
                    params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);
                    // token needs to be appended here after buildURL, to ensure it's not added twice to return_url
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_integration.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            var models = {};
            var capeData = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);

                return creditDataModel.action('readCreditKey', {
                    data: {
                        capeKey: creditDataModel.getCapeKey()
                    },
                    success: function success(res) {
                        capeData = res;
                        return (0, _squid.$populate)(models, {
                            creditDataModel: creditDataModel
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var financial_instrument_id = capeData.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + capeData.financial_instrument_id : capeData.financial_instrument_id;
                var checkoutSession = _index.$CheckoutSessionModel.instance(_angular.$rootScope.token);

                return checkoutSession.action('create', {
                    data: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    params: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    success: function success() {
                        return (0, _squid.$populate)(models, {
                            checkoutSession: checkoutSession
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutAppData, models.checkoutSession, returnToMerchantMethod);

                return models.checkoutSession.action('authorize', {
                    data: {
                        pmode: 'FAST'
                    },
                    success: function success() {
                        if (returnToMerchantMethod === 'POST') {
                            _util.$ReturnToMerchant.postTo(url, params);
                        } else {
                            // if PDT is disabled don't send params in the url
                            if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                                return _util.$ReturnToMerchant.goTo(url);
                            }
                            _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                        }
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            })['catch'](function () {
                return 'checkout.genericError';
            });
        }
    }
});

angular.value("$xoDeGuest", $xoDeGuest);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_squid.$ComponentRoute;

_squid.$populate;

_squid.$promise;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_credit.$CreditDataModel;

_profilemanagement.$MerchantPreferenceModel;

_util.$ReturnToMerchant;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-de-guest/route.js
// module id = ./pages/xo-de-guest/route.js
// module chunks = 0